import React, { FC } from 'react';
import { FloatingNotification } from '../../../components/common';
import { IOuter } from './GenericNotification.types';
import styles from './notifications.scss';

export const GenericNotification: FC<IOuter> = ({ notification, text, buttonProps, type, dataHook }) => (
  <FloatingNotification
    className={styles.notification}
    onClose={notification.dismiss}
    text={text}
    buttonProps={buttonProps}
    type={type}
    dataHook={dataHook}
  />
);
